import React from "react";
import PageLayout from "../../components/PageLayout";
import OBHavingTroubleCard from "../onboarding/_components/OBHavingTroubleCard";
import BookingDetailMainWrapper from "./components/BookingDetailMainWrapper";
import { useParams } from "react-router-dom";
function BookingDetailMain() {
  // get the id from the url
  const { id } = useParams();
  return (
    <PageLayout>
      <section className="d-flex flex-1xl-nowrap flex-column flex-wrap flex-xl-row align-items-start gap-3 product-listing-main-wrapper-section">
        <BookingDetailMainWrapper id={id} />
        {/* <OBHavingTroubleCard /> */}
      </section>
    </PageLayout>
  );
}

export default BookingDetailMain;
